var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HistoryTabTemplate',{attrs:{"items":_vm.items,"loading":_vm.loading}},[_vm._l((_vm.itemsSort),function(historyItem,itemIndex){return [_c(historyItem.component,{key:`event-history-${itemIndex}-new`,tag:"component",staticClass:"mt-4",attrs:{"data-qa":`event-history-${itemIndex}`,"item":historyItem,"spr":_vm.spr}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }